import { Query, type Models } from "appwrite";
import { databases } from "@/lib/appwrite";
import { calculateBalance, fromAppwriteDatetime, localDateToISO, type BalanceSummary } from "../vacationBalanceService";
import { getTakenDays } from "../vacationsService";
import { getCantonByBranch } from "@/holidays/lib/branches";


const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const WORKER_PROFILE_COLLECTION_ID = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID;

type WorkerDoc = Models.Document & {
    userId: string;
    firstName?: string | null;
    lastName?: string | null;
    joinDate?: string | null;
    birthday?: string | null;
    branch?: string | null;
    isIntern?: boolean | null;
    payrollStartDate?: string | null;
};

export type VacationOverview = {
    fullName: string;
    canton: string | null; // null = la sucursal del empleado no está en BRANCHES
    balance: BalanceSummary;
};

export async function getVacationOverview(userId: string): Promise<VacationOverview> {
    const [profiles, daysTaken] = await Promise.all([
        databases.listDocuments<WorkerDoc>(DATABASE_ID, WORKER_PROFILE_COLLECTION_ID, [
            Query.equal("userId", userId),
            Query.select(["userId", "firstName", "lastName", "joinDate", "birthday", "branch", "isIntern", "payrollStartDate"]),
            Query.limit(1),
        ]),
        getTakenDays(userId),
    ]);

    const profile = profiles.documents[0];
    if (!profile) throw new Error("PROFILE_NOT_FOUND");
    if (profile.isIntern) throw new Error("NOT_ELIGIBLE");

    const serviceStart = profile.payrollStartDate ?? profile.joinDate;
    if (!serviceStart || !profile.birthday) throw new Error("MISSING_DATES");

    const balance = calculateBalance({
        joinDate: fromAppwriteDatetime(serviceStart),
        birthday: fromAppwriteDatetime(profile.birthday),
        asOf: localDateToISO(new Date()),
        daysTaken,
    });

    return {
        fullName: [profile.firstName, profile.lastName].filter(Boolean).join(" "),
        canton: getCantonByBranch(profile.branch),
        balance,
    };
}